/*
 * Public API Surface of percentage-bar
 */

export * from './percentage-bar.module';
